import styled from 'styled-components';
import * as constants from '../../../constants/styles';

const {
    breadcrumbText,
    breadcrumbBorder,
    subtitle,
    primary,
    third,
    whiteDark
} = constants

export const Container = styled.div.attrs(props => ({
    theme: props.theme,
    className: "contentComponent"
}))`
    width: 100%;
    min-height: 100%!important;
    background: ${third};
    padding:6% 4% 0 6%;
    div.headerContainer{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        div.titleContainer {
            display: flex;
            flex-direction: column;
            span.title {
                font-size: 16pt;
                font-weight: 800;
                color:  ${props => constants[props.theme] ? constants[props.theme] : primary};
            }
            span.subTitle {
                color: ${subtitle};
                font-size: 11pt;
            }
        }

        ul {
            background: ${whiteDark};
            color: ${breadcrumbText};
            padding: 10px;
            border-radius: 20px;
            font-size: 10pt;
            li {
                list-style: none;
                padding: 0 10px;
                display: inline-block;
                position: relative;
                z-index: 0;

                &:last-child {
                    font-weight: bolder;
                    padding: 0 10px;
                    &::before,
                    &::after {
                       border: none;
                    }
                }

                &:first-child {
                    &::before,
                    &::after {
                       border: none;
                    }
                }


                &::before, &::after {
                    content: '';
                    position: absolute;
                    left: -2px;
                    height: 30%;
                    width: 100%;
                    border-left: 2px solid ${breadcrumbBorder};
                    border-right: 2px solid ${breadcrumbBorder};
                }

                &::before {
                    top: 5px;
                    transform: skew(30deg);
                }

                &::after {
                    bottom: 5px;
                    transform: skew(-30deg);
                }
            }
        }
    }

    @media only screen and (max-width: 360px) {
        padding:80px 4% 0 6%;
        div.headerContainer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            div.titleContainer {
                span.title {
                    font-size: 14pt;
                }
                span.subTitle {
                    font-size: 8pt;
                }
            }
            ul{
                padding: 0 0px 10px 10px;
                border-radius: 20px;
                li {
                    font-size: 7pt;
                    padding: 10px 10px 0 8px;
                    &::before {
                        top: 10px;
                        transform: skew(35deg);
                    }

                    &::after {
                        bottom: 0px;
                        transform: skew(-35deg);
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 360px) and (max-width: 768px) {
        padding:100px 4% 0 6%;
        div.headerContainer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            div.titleContainer {
                span.title {
                    font-size: 14pt;
                }
                span.subTitle {
                    font-size: 8pt;
                }
            }
            ul{
                padding: 0 0px 10px 10px;
                border-radius: 20px;
                li {
                    font-size: 7pt;
                    padding: 10px 10px 0 10px ;
                    &::before {
                        top: 10px;
                        transform: skew(45deg);
                    }

                    &::after {
                        bottom: 0px;
                        transform: skew(-45deg);
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1280px) {
        padding:80px 4% 0 3%;
        div.headerContainer{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            max-width: 100%;
            div.titleContainer {
                span.title {
                    font-size: 14pt;
                }
                span.subTitle {
                    font-size: 8pt;
                }
            }
            ul{
                padding: 0 0px 10px 10px;
                border-radius: 20px;
                li {
                    font-size: 8pt;
                    padding: 10px 10px 0 10px;
                    &::before {
                        top: 10px;
                        transform: skew(45deg);
                    }

                    &::after {
                        bottom: 1px;
                        transform: skew(-45deg);
                    }
                }
            }
        }
    }

`;
